import { PropsWithChildren, ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  Stack,
} from "@mui/material";
import styles from "./Modal.styles";

export type TModalProps = Pick<
  DialogProps,
  "children" | "maxWidth" | "scroll" | "sx" | "title" | "fullWidth" | "onClick"
> & { open: boolean; header?: ReactNode; actions?: ReactNode };

const Modal = ({
  sx,
  title,
  header,
  actions,
  ...props
}: PropsWithChildren<TModalProps>) => {
  const combinedStyles = {
    ...styles.dialog,
    ...sx,
  };

  if (!props.open) {
    return null;
  }

  return (
    <Dialog sx={combinedStyles} {...props}>
      <Stack>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {title && <DialogTitle width="100%">{title}</DialogTitle>}
        </Stack>
        {header}
      </Stack>
      {props.children ? <DialogContent>{props.children}</DialogContent> : null}
      {actions}
    </Dialog>
  );
};

export default Modal;
